const API_BASE = "https://winenew.sipstocks.in";

export default API_BASE;
